import React, {forwardRef, useState, useEffect} from 'react';
import DatePicker from "react-datepicker";

type TextFieldInputProps = {
    isDatePicker?: boolean
    label: string;
    value: string;
}

type DatePickerInputProps = {
    fieldName: string
    value?: string;
    onClick?: () => void;
    onChange?: () => void;
};

export const DatePickerSimpleCustomInput = forwardRef<HTMLInputElement, DatePickerInputProps>(
    ({fieldName, value, onClick, onChange}, ref) =>
        (
            <div>
                <input
                    className="ml-4 border block p-1 rounded"
                    id={fieldName}
                    value={value}
                    onClick={onClick}
                    onChange={onChange}
                    ref={ref}
                />
            </div>
        )
);

export function TextFieldInput({label, value, isDatePicker = false}: TextFieldInputProps) {
    const [currentInput, setCurrentInput] = useState<string | Date>(value);
    // HACK for the demo only, we should use React hook form state instead
    useEffect(() => {
        setCurrentInput(value);
    }, [value])


    return (
        <li className="w-full flex text-base items-center pb-2">
            <div className="w-2/6 text-right">
                {label}
            </div>
            {
                isDatePicker &&
                <DatePicker
                    wrapperClassName="w-3/6"
                    selected={currentInput as Date}
                    onChange={(newValue: Date | null) => setCurrentInput(newValue as Date)}
                    customInput={<DatePickerSimpleCustomInput
                        fieldName="fromDate"
                        value={new Date().toISOString()}
                    />}
                />
            }
            {
                !isDatePicker &&
                <input
                    className="w-3/6 ml-4 border block p-1 rounded"
                    onChange={(e) => setCurrentInput(e.target.value)}
                    value={currentInput as string}
                />
            }
        </li>
    );
}